import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-utility-lib',
  template: `
    <p>
      utility-lib works! 15h15555555555555555
    </p>
  `,
  styles: []
})
export class UtilityLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
